<template>
  <div class="app-container">
    <!-- 页面内容 -->
    <div class="container-page">

      <!-- 筛选条件 -->
      <div class="filter-container filter-box filter-flex">
        <div class="left-box">
          <!-- 外包商模糊搜索 -->
          <el-input class="filter-item input_search" v-model="listQuery.keyword" placeholder="标签类型模糊搜索" clearable @keyup.enter.native="handleFilter" @input="handleFilter" @clear="handleFilter" style="width: 240px">
            <svg-icon slot="prefix" class="el-input__icon icon" icon-class="search_shape" />
          </el-input>

        </div>

        <div class="right-box">

          <!-- 操作按钮 -->
          <div class="filter-container filter-box">
            <!-- v-if="accessPoint['outsource:delete']" -->
            <el-button class="filter-item button_delete" :loading="downloadLoading" @click="selectDelete">
              <svg-icon icon-class="delete_shape" />
              <span class="button_span">批量删除</span>
            </el-button>

            <!-- <el-popover width="400" trigger="click" style="margin:0 15px">
              <el-button slot="reference" class="filter-item button_filter">
                <svg-icon icon-class="combined_shape" />
                <span class="button_span_style">筛选列</span>
              </el-button>

              <el-checkbox-group class="checkbox-table-headers" v-model="checkboxTitle">
                <el-checkbox v-for="(item, index) in tableTheadOptions" :key="index" :label="item" :disabled="index == 0">{{ item[Object.keys(item)[0]] }}</el-checkbox>
              </el-checkbox-group>
            </el-popover> -->

            <el-button class="filter-item button_add" type="primary" @click="handleAdd" v-if="accessPoint['outsource:create']">
              <i class="el-icon-plus" />
              <span class="button_span">添加标签类型</span>
            </el-button>

          </div>

        </div>
      </div>

      <!-- 表格 -->
      <el-table ref="table" class="grayTableTile_02" v-loading="tableloading" :data="tableList" :show-overflow-tooltip="true" :header-cell-style="{'background-color':'#f7f7f7','color':'#999'}" @sort-change="sortFun"
        @selection-change='handleSelectionChange' height='635'>
        <el-table-column type="selection" width="55">
        </el-table-column>
        <el-table-column v-for="(item, index) in tableTheads" :key="index" :label="item[Object.keys(item)[0]]" :prop="Object.keys(item)[0]"  :sortable="item['sortable']"
          show-overflow-tooltip :min-width="
            Object.keys(item)[0] == 'name'
              ? 300
              : 150
          ">
          <template slot-scope="scope">
            <span v-if="index == 0" class="titleClass" @click="titleClick(scope.row)">{{scope.row[Object.keys(item)[0]]}}</span>
            <span v-else-if="scope.row[Object.keys(item)[0]]" @click="previewFun(scope.row[Object.keys(item)[0]])">{{ scope.row[Object.keys(item)[0]] }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>

        <el-table-column :fixed="tableList.length>0?'right':false" align="right" header-align="right" label="操作" width="100" v-if="accessPoint['outsource:edit'] || accessPoint['outsource:delete']">
          <template slot-scope="scope">
            <el-button type="text" @click="handleEdit(scope.row)" v-if="accessPoint['outsource:edit']">编辑</el-button>
            <div class="line" v-if="accessPoint['outsource:edit'] && accessPoint['outsource:delete']"></div>
            <el-button type="text" @click="handleDelete(scope.row)" v-if="accessPoint['outsource:delete']">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <pagination class="pagination" style="padding-bottom:0px" v-show="total > 0" :total="total" :page.sync="listQuery.pageNo" :limit.sync="listQuery.pageSize" />
    </div>

    <!-- 添加 编辑 -->
    <addEditorTag ref="add_editor"></addEditorTag>

    <!-- 标签详情 -->
    <tagInfo ref="infoDialog"></tagInfo>

    <!-- 展示详情小dialog -->
    <el-dialog :visible.sync="dialogVisible" title="详情" width='33%'>
      <ul>
        <li v-for="(item,index) of dialogContent" :key='index' class="liClass">
          {{item}}
        </li>
      </ul>

    </el-dialog>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import addEditorTag from "./components/addEditorTag.vue";
import tagInfo from "./components/tagInfo.vue";
import { outsource_outsourcerList, config_outsourcerLabel, outsource_deleteOutsourcer } from "@File~/api/outsourcing";
import { arrSlice, sortKeys } from '@/filters'



const defaultFormThead = [
  { name: "标签类型", sortable: "custom" },
  { isCooperateStr: "应用位置" },
  { typeName: "备注" },
];

export default {
  components: { Pagination, addEditorTag, tagInfo },
  data() {
    return {
      dialogVisible: false,
      dialogContent: [],


      accessPoint: this.$store.getters.accessPoint, //权限点

      styleLabelsOptions: [],
      technologysOptions: [],
      gradesOptions: [],
      isHeroCollaboratorsOptions: [{ id: '1', name: '是' }, { id: '-1', name: '否' }],
      typesOptions: [],
      isCooperateOptions: [],
      postTypeOptions: [],
      isNewCollaboratorsOptions: [],
      projectOptions: [],

      downloadLoading: false,

      tableTheadOptions: defaultFormThead, // 筛选列
      checkboxTitle: defaultFormThead, // 默认选中

      // 表格
      tableloading: false,
      tableTheads: defaultFormThead,
      multipleSelection: [],

      originalCaseTable: [], // 原始数据
      caseTable: [],// 排序后数据
      handCaseTable: [], // 存放处理假分页后的数据(等距切割)
      tableData: [], // 切割后页面应展示的数据

      total: 0,
      listQuery: {
        pageNo: 1,
        pageSize: 10,
        keyword: "",
      },
    };
  },
  computed: {
    // 筛选列表表
    tableList() {
      let caseTable = this.caseTable
      if (caseTable.length > 0) {
        this.total = caseTable.length
        // 将一维数组切割成二维数组
        this.handCaseTable = arrSlice(caseTable, this.listQuery.pageSize)
        this.tableData = this.handCaseTable[this.listQuery.pageNo - 1]
      } else {
        this.tableData = []
      }
      return this.tableData
    },
  },
  watch: {
    // 筛选table header
    checkboxTitle(valArr) {
      this.tableTheads = this.tableTheadOptions.filter(
        (i) => JSON.stringify(valArr).indexOf(JSON.stringify(i)) > -1
      );
      // console.log('=======',this.tableTheads)
    },
  },
  created() {
    this.getList();

  },
  methods: {
    titleClick(row) { 
        console.log(row)
        this.$refs.infoDialog.init(row);

    },
    previewFun(data) {
      this.dialogContent = []
      if (data.length > 8) {
        if (data.indexOf(',') !== -1 || data.indexOf('，') !== -1) {
          let tempArr = data.indexOf(',') !== -1 ? data.split(',') : data.split('，')
          tempArr.map((item) => {
            this.dialogContent.push(item)
          })
        } else {
          this.dialogContent.push(data)
        }
        this.dialogVisible = true;

      }


    },

    handleSelectionChange(val) {
      this.multipleSelection = val

    },
    sortFun(e) {
      // this.listQuery.orderByType = e.order == 'ascending' ? 2 : 1
      // this.getList()
      if (e.order) {
        const order = e.order == 'descending' ? false : true
        this.caseTable.sort(sortKeys(e.prop, order))
      } else {
        this.caseTable = JSON.parse(JSON.stringify(this.originalCaseTable))
      }
    },
    // 获取列表
    getList() {
      var tempTime1 = new Date().getTime();
      this.tableloading = true;
      let tempObj = {};
      for (let key in this.listQuery) {
        tempObj[key] = this.listQuery[key]
      }
      tempObj['inListTimeStr'] = tempObj['inListTimeStr'] && tempObj['inListTimeStr'].length > 0 ? tempObj['inListTimeStr'].join(' - ') : '';
      outsource_outsourcerList(tempObj).then((response) => {
        if (response.code == 1) {
          console.log(new Date().getTime() - tempTime1);
          this.total = response.data.length;
          response.data.map((item) => {
            item.isHeroCollaboratorName = item.isHeroCollaborator === 1 ? '是' : item.isHeroCollaborator === -1 ? '否' : '';
          })

          this.caseTable = response.data;
          this.originalCaseTable = JSON.parse(JSON.stringify(response.data))
          this.$refs.table.clearSort()
          // this.tableData = response.data.result;
          this.tableloading = false;
        }
      });
    },



    // 搜索
    handleFilter() {
      this.listQuery.pageNo = 1;
      this.getList();
    },

    // 下载
    selectDelete() {

    },

    // 删除
    handleDelete(row) {
      this.$confirm("确定要删除该标签吗？", "删除标签", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "button-primary-plain",
        type: "warning",
      })
        .then(() => {
          //   outsource_deleteOutsourcer(row.id).then((response) => {
          //     if (response.code == 1) {
          //       this.$message({ type: 'success', message: '删除成功' })
          //       this.getList()
          //     }
          //   })
        })
        .catch(() => {
        });
    },

    // 添加
    handleAdd() {
      let data = {
        styleLabelsOptions: this.styleLabelsOptions,
        technologysOptions: this.technologysOptions,
        gradesOptions: this.gradesOptions,
        typesOptions: this.typesOptions,
        isCooperateOptions: this.isCooperateOptions,
        //岗位分类
        postTypeOptions: this.postTypeOptions,
        //是否已签新外包协议
        isNewCollaboratorsOptions: this.isNewCollaboratorsOptions,
        isHeroCollaboratorsOptions: this.isHeroCollaboratorsOptions,
        projectOptions: this.projectOptions,
      }
      this.$refs["add_editor"].init("add", data, null);
    },

    // 编辑
    handleEdit(row) {
      let data = {
        styleLabelsOptions: this.styleLabelsOptions,
        technologysOptions: this.technologysOptions,
        gradesOptions: this.gradesOptions,
        typesOptions: this.typesOptions,
        isCooperateOptions: this.isCooperateOptions,
        postTypeOptions: this.postTypeOptions,
        isNewCollaboratorsOptions: this.isNewCollaboratorsOptions,
        isHeroCollaboratorsOptions: this.isHeroCollaboratorsOptions,
        projectOptions: this.projectOptions,
      }
      this.$refs["add_editor"].init("edit", data, row);
    },
  },
};
</script>

<style lang="scss" scoped>
.app-container {
  padding: 16px 32px 61px;
  min-height: calc(100vh - 50px);
  overflow: hidden;
  background: #f5f5f5;
}
.container-page {
  // height: calc(100vh - 71px);
  padding: 24px 24px;
  background: #ffffff;
  border-radius: 4px;
  position: relative;
}

.filter-box {
  .button_span {
    margin-left: 4px;
  }

  ::v-deep .el-input__inner {
    background: #ffffff;
    box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.04);
    border-radius: 4px;
    border: 1px solid #e5e5e5;
    color: #333;
  }

  // ::v-deep .el-icon-arrow-up:before {
  //   content: "\E78F";
  //   color: #666;
  // }
}

.filter-flex {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: flex-start;
}

.right-box {
  flex-shrink: 0;
  width: 340px;
  text-align: right;
}

.button_filter {
  background: #ffffff;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.08);
  border-radius: 6px;
  border: 1px solid #e5e5e5;
  padding: 10px 12px;
}

// input search
.input_search {
  ::v-deep .el-input__inner {
    padding-left: 44px;
  }
  ::v-deep .el-input__prefix {
    width: 20px;
    height: 20px;
    margin: 8px 12px 8px 12px;
    .icon {
      width: 20px;
      height: 20px;
    }
  }
}

// 新增按钮
.button_add {
  padding: 10px 16px;
}

// 下载按钮
.button_delete {
  background: #ffffff;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.08);
  border-radius: 6px;
  border: 1px solid #e5e5e5;
  padding: 10px 12px;
}

.line {
  display: inline-block;
  width: 2px;
  height: 16px;
  background: #ccc;
  vertical-align: middle;
  margin: 0 3px 3px;
}

// 表格固定 滚动
// .grayTableTile_02 ::v-deep .el-table__body-wrapper {
//     z-index: 1;
// }

.titleClass {
  width: 300px;
  color: #3a89ff;
  cursor: pointer;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  &:hover {
    text-decoration: underline;
  }
}

::v-deep .el-table__fixed {
  height: 623px !important;
}
::v-deep .el-table__fixed-right {
  height: 623px !important;
}

::v-deep .el-table__body-wrapper::-webkit-scrollbar {
  width: 6px; // 横向滚动条
  height: 10px; // 纵向滚动条 必写
}
// 滚动条的滑块
::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background-color: #ddd;
  border-radius: 5px;
}

// table 定位有条线
::v-deep .el-table__fixed-right:before,
::v-deep .el-table__fixed:before {
  background-color: transparent;
}

.select-box {
  ::v-deep .el-select__tags {
    .el-tag {
      max-width: 60%;
      overflow: hidden;
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      align-items: center;
      .el-select__tags-text {
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    .el-select__input {
      margin-left: 2px;
    }
  }
  ::v-deep .el-select-dropdown__item {
    padding: 0 20px 0 10px;
  }
  ::v-deep .el-select-dropdown__item.selected::after {
    right: 5px;
  }
}

.dateClass {
  ::v-deep .el-icon-date:before {
    content: url("../../assets/date.png");
    position: absolute;
    top: 6px;
    left: 10px;
  }
}

.liClass {
  display: block;
  line-height: 35px;
}
</style>
